import { stringifyQs } from "@dashboard/utils/urls";

export const sellingUnitsSection = "/selling-units/";

export const sellingUnitListPath = sellingUnitsSection;
export const sellingUnitListUrl = (params?: Record<string, unknown>) =>
  sellingUnitListPath + (params ? "?" + stringifyQs(params) : "");

export const sellingUnitAddPath = sellingUnitsSection + "add";
export const sellingUnitAddUrl = sellingUnitAddPath;

export const sellingUnitDetailPath = (id: string) => sellingUnitsSection + id;
export const sellingUnitDetailUrl = (id: string) =>
  sellingUnitDetailPath(encodeURIComponent(id));
